import { render, staticRenderFns } from "./MonitoraggioPressioneViewComponent.vue?vue&type=template&id=e3e787b2"
import script from "./MonitoraggioPressioneViewComponent.vue?vue&type=script&lang=js"
export * from "./MonitoraggioPressioneViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports